export default "__VITE_ASSET__DPtbdtAv__"